export const AcceptedImages = ['image/*'] as const;

export const AcceptedFiles = ['.csv'] as const;

export const AcceptedFileMaxSizeMB = 80;
export const AcceptedFileMaxSize = AcceptedFileMaxSizeMB * 1000 * 1000;
